import {
  DELETE_STATEMENT_REQUEST,
  DELETE_STATEMENT_SUCCESS,
  DELETE_STATEMENT_FAILURE,
} from '../../actions/statements/statementActionTypes';

const initialState = {
  loading: false,
  response: '',
  error: '',
  fetched: false,
};

interface Payload {
  Id: number;
  AffiliateName: string;
  DocumentFieldId: string;
  FileName: string;
  Month: string;
  Year: number;
}
interface DelStatements {
  payload: Payload;
  type: string;
}

const deleteStatementReducer = ( state = initialState, action: DelStatements):any => {
  switch (action.type) {
    case DELETE_STATEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        fetched: false,
      };
    case DELETE_STATEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        error: '',
        fetched: true,
      };
    case DELETE_STATEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        response: '',
        error: action.payload,
        fetched: false,
      };
    default:
      return state;
  }
};

export default deleteStatementReducer;
